/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-27 00:00:00
 *
 *******************************************************/
import React, { Component } from 'react';
import { Button, Icon, TextStyle } from '@shopify/polaris';
import { EditMinor, CodeMajor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';

class SelectTemplate extends Component {
  render() {
    const {  templates, updateCurrentSection } = this.props;
    return (
      <div className="visual-editor-settings">
        <div className="card-section title-bold-normal">
          <div className="title-line word-break">
            <Icon source={EditMinor} color="subdued" />
            <TextStyle variation="subdued">
              {templates && templates[0] && templates[0].widgetName}
            </TextStyle>
            <div className="edit-sections">
              {templates.map(template => (
                <React.Fragment key={template.widgetId}>
                  <Button
                    plain
                    monochrome
                    textAlign="left"
                    fullWidth
                    icon={CodeMajor}
                    onClick={() => updateCurrentSection(template)}>
                    {template.widgetName}
                  </Button>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withI18n()(SelectTemplate);
